/* eslint-disable camelcase */
import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Models
import mCustomer from 'models/customer';
// Core components
import Tooltip from 'components/core/Tooltip';
// Custom
import {
  ONEPARK_LINK_ADMIN_BOOKING,
  ONEPARK_LINK_BACKOFFICE,
} from 'constants/App';
import { customerDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';

const CustomerOPInfo = ({ customer }) => {
  const { labelId, icon } = mCustomer.opBookingUsage(customer);
  const {
    metadata: { booking_id },
  } = customer;

  let pathOnepark;
  if (mCustomer.isOpBookingUsageB2b(customer)) {
    pathOnepark = `${ONEPARK_LINK_BACKOFFICE}${booking_id}`;
  } else {
    pathOnepark = `${ONEPARK_LINK_ADMIN_BOOKING}${booking_id}`;
  }

  const accessKeypadCode = mCustomer.getAccessKeypadCode(customer);

  return (
    <div className="d-flex align-items-center">
      <div className="d-flex align-items-center mr-2">
        <Tooltip content={<LocalizedMessage id={labelId} />}>
          <AppIcon defaultColor id={icon} />
        </Tooltip>
      </div>
      <a href={pathOnepark} target="_blank" rel="noreferrer">
        <u>{booking_id}</u>
      </a>
      {' - '}
      {accessKeypadCode}
    </div>
  );
};

CustomerOPInfo.propTypes = {
  customer: customerDataShape.isRequired,
};

module.exports = CustomerOPInfo;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/CustomerOPInfo.js